export default "__VITE_ASSET__BP1R$hCW__"